const ROCKETDATA_FEATURE_HELP_URLS_RU = {
  agent_bots:
    'https://roketdata.helpdeskeddy.com/ru/knowledge_base/article/840/category/80/',
  agents:
    'https://roketdata.helpdeskeddy.com/ru/knowledge_base/article/841/category/83/',
  audit_logs:
    'https://roketdata.helpdeskeddy.com/ru/knowledge_base/article/829/category/80/',
  campaigns:
    'https://roketdata.helpdeskeddy.com/ru/knowledge_base/article/842/category/80/',
  canned_responses:
    'https://roketdata.helpdeskeddy.com/ru/knowledge_base/article/830/category/83/',
  channel_email:
    'https://roketdata.helpdeskeddy.com/ru/knowledge_base/article/831/category/80/',
  channel_facebook:
    'https://roketdata.helpdeskeddy.com/ru/knowledge_base/article/832/category/80/',
  custom_attributes:
    'https://roketdata.helpdeskeddy.com/ru/knowledge_base/article/833/category/83/',
  inboxes: 'https://roketdata.helpdeskeddy.com/ru/knowledge_base/category/81/',
  labels:
    'https://roketdata.helpdeskeddy.com/ru/knowledge_base/article/835/category/83/',
  macros:
    'https://roketdata.helpdeskeddy.com/ru/knowledge_base/article/836/category/83/',
  reports:
    'https://roketdata.helpdeskeddy.com/ru/knowledge_base/article/838/category/80/',
  sla: 'https://roketdata.helpdeskeddy.com/ru/knowledge_base/article/839/category/80/',

  automation:
    'https://roketdata.helpdeskeddy.com/ru/knowledge_base/art/839/cat/83/',
  team_management:
    'https://roketdata.helpdeskeddy.com/ru/knowledge_base/article/863/category/83/',
};

const ROCKETDATA_FEATURE_HELP_URLS_EN = {
  agent_bots:
    'https://roketdata.helpdeskeddy.com/en/knowledge_base/article/840/category/80/',
  agents:
    'https://roketdata.helpdeskeddy.com/en/knowledge_base/art/841/cat/83/agents',
  audit_logs:
    'https://roketdata.helpdeskeddy.com/en/knowledge_base/article/829/category/80/',
  campaigns:
    'https://roketdata.helpdeskeddy.com/en/knowledge_base/article/842/category/80/',
  canned_responses:
    'https://roketdata.helpdeskeddy.com/en/knowledge_base/art/830/cat/83/how-to-create-and-use-canned-responses',
  channel_email:
    'https://roketdata.helpdeskeddy.com/en/knowledge_base/article/831/category/80/',
  channel_facebook:
    'https://roketdata.helpdeskeddy.com/en/knowledge_base/article/832/category/80/',
  custom_attributes:
    'https://roketdata.helpdeskeddy.com/en/knowledge_base/art/833/cat/83/how-to-create-and-use-custom-attributes',
  inboxes:
    'https://roketdata.helpdeskeddy.com/en/knowledge_base/cat/81/adding-inboxes',
  labels:
    'https://roketdata.helpdeskeddy.com/en/knowledge_base/art/835/cat/83/how-to-create-and-use-labels',
  macros:
    'https://roketdata.helpdeskeddy.com/en/knowledge_base/art/836/cat/83/how-to-create-and-use-macros',
  reports:
    'https://roketdata.helpdeskeddy.com/en/knowledge_base/article/838/category/80/',
  sla: 'https://roketdata.helpdeskeddy.com/en/knowledge_base/article/839/category/80/',

  automation:
    'https://roketdata.helpdeskeddy.com/en/knowledge_base/art/839/cat/83/automation-service-level-agreements',
  team_management:
    'https://roketdata.helpdeskeddy.com/en/knowledge_base/art/863/cat/83/how-to-create-operator-teams/',
};

const BRANDWIZARD_FEATURE_HELP_URLS = {};

export function useDomainContext() {
  const isBrandWizard = true;

  function getHelpUrlForFeature(featureName, locale) {
    if (isBrandWizard) {
      return BRANDWIZARD_FEATURE_HELP_URLS[featureName];
    }

    if (locale === 'ru') {
      return ROCKETDATA_FEATURE_HELP_URLS_RU[featureName];
    }

    return ROCKETDATA_FEATURE_HELP_URLS_EN[featureName];
  }

  return {
    vkAllowed: !isBrandWizard,
    showFooter: !isBrandWizard,
    customerProfileUrl: isBrandWizard
      ? 'https://go.brandwizard.io'
      : 'https://go.rocketdata.io',
    getHelpUrlForFeature,
  };
}
